import { Injectable, Optional } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
    MissionService,
    SimpleMissionDto
} from '@flyfreely-portal-ui/flyfreely';
import { OperationsSearchDataService } from '@flyfreely-portal-ui/operations-shared';
import { SitesDataService } from '@flyfreely-portal-ui/sites-shared';
import { deepEqual } from 'fast-equals';
import {
    combineLatest,
    distinctUntilChanged,
    filter,
    of,
    ReplaySubject,
    switchMap
} from 'rxjs';

@Injectable()
export class ExternalMissionsDataService {
    private externalMissionListSource = new ReplaySubject<SimpleMissionDto[]>(
        1
    );
    missionList$ = this.externalMissionListSource.asObservable();
    constructor(
        operationsSearchDataService: OperationsSearchDataService,
        private missionService: MissionService,
        @Optional() sitesDataService: SitesDataService
    ) {
        if (sitesDataService != null) {
            combineLatest([
                sitesDataService.sites$,
                operationsSearchDataService.currentSearch$.pipe(
                    distinctUntilChanged(deepEqual)
                )
            ])
                .pipe(
                    filter(
                        ([sites, search]) =>
                            sites.organisationId === search.organisationId
                    ),
                    switchMap(([sites, criteria]) => {
                        if (
                            sites.siteList.length === 0 ||
                            criteria.organisationId == null ||
                            criteria.time == null ||
                            criteria.time.start == null ||
                            criteria.time.end == null
                        ) {
                            return of([]);
                        }

                        return this.missionService.findExternalMissions({
                            managingOrganisationId: criteria.organisationId!,
                            time: criteria.time!,
                            includedSiteIdList: sites.siteList
                                .filter(s => !s.archived)
                                .map(s => s.id)
                        });
                    }),
                    takeUntilDestroyed()
                )
                .subscribe(missionList => {
                    this.externalMissionListSource.next(missionList);
                });
        }
    }
}
